import Vue from 'vue'
import App from './App'
import router from './router'
import $ from './assets/jquery_loader.js'
import elementUI from 'element-ui'
import suite from './assets/suite'

Vue.config.productionTip = false

// 相關套件
Vue.prototype.suite = suite
Vue.use(suite)
Vue.use(elementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js